/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openthispagefromyourinviteemail6Inputs */

const en_openthispagefromyourinviteemail6 = /** @type {(inputs: Openthispagefromyourinviteemail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open this page from the link in your invite email.`)
};

const de_openthispagefromyourinviteemail6 = /** @type {(inputs: Openthispagefromyourinviteemail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne diese Seite über den Link in deiner Einladungs-E-Mail.`)
};

/**
* | output |
* | --- |
* | "Open this page from the link in your invite email." |
*
* @param {Openthispagefromyourinviteemail6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const openthispagefromyourinviteemail6 = /** @type {((inputs?: Openthispagefromyourinviteemail6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openthispagefromyourinviteemail6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openthispagefromyourinviteemail6(inputs)
	return de_openthispagefromyourinviteemail6(inputs)
});
export { openthispagefromyourinviteemail6 as "openThisPageFromYourInviteEmail" }